import { Component } from "@angular/core"
import { CardMetaComponent } from "../card-meta.component"

@Component({
    selector: "app-mfr-card-meta",
    templateUrl: "./mfr-card-meta.component.html",
    styleUrls: ["./mfr-card-meta.component.scss"],
    standalone: false,
})
export class MfrCardMetaComponent extends CardMetaComponent {}
